(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .component('sc3MemberCourseList', {
            templateUrl: 'app/member-admin/member-course-list/member-course-list.component.html',
            controller: MemberCourseListComponent,
            bindings: {
                individualId: '<',
                courseList: '<'
            }
        });

    MemberCourseListComponent.$inject = [];
    function MemberCourseListComponent() {
        var ctrl = this;
        ctrl.courseList = [];
        ctrl.insert = insert
        ctrl.remove = remove;

        //////////////////////

        function insert() {
            ctrl.courseList.push({ individualId: ctrl.individualId, $new: true });
        }

        function remove(course) {
            var index = ctrl.courseList.indexOf(course);
            if (index >= 0)
                ctrl.courseList.splice(index, 1);
        }
    }
})();
